<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { useIdleSession } from '~/composables/useIdleSession'

const { isDark } = storeToRefs(useContextStore())
const { isWarningVisible, remainingSeconds, stayLoggedIn, logout } = useIdleSession()

function handleStayLoggedIn() {
  stayLoggedIn()
}

function handleLogout() {
  logout()
}
</script>

<template>
  <v-dialog
    v-model="isWarningVisible"
    persistent
    max-width="650"
  >
    <v-card rounded="lg">
      <v-card-title
        class="px-6 py-4 d-flex align-center"
        :class="`bg-grey-${isDark ? 'darken-3' : 'lighten-4'}`"
      >
        <v-icon
          class="mr-3"
          color="warning"
          icon="mdi-clock-alert-outline"
        />
        <span>Session Expiration Warning</span>
      </v-card-title>
      <v-divider />

      <v-card-text class="pa-6">
        <p class="text-body-1 mb-4">
          You have been inactive for a while. For your security, your session will automatically expire in:
        </p>
        <div class="d-flex justify-center my-4">
          <v-chip
            color="warning"
            size="x-large"
            variant="flat"
            class="text-h5 font-weight-bold px-6 py-4"
          >
            {{ remainingSeconds }} seconds
          </v-chip>
        </div>
        <p class="text-body-2 text-medium-emphasis mb-0 text-center">
          Click "Stay Logged In" to continue your session.
        </p>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-4">
        <v-spacer />
        <FormCancelButton
          :block="false"
          @click="handleLogout"
        >
          Log Out
        </FormCancelButton>
        <FormSaveButton
          :block="false"
          @click="handleStayLoggedIn"
        >
          Stay Logged In
        </FormSaveButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
